import React, { useEffect } from 'react'
import { BaseNodeProps } from '../../base/types'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { TransformScriptConfiguration } from './TransformScriptForm'

//
const TransformScriptNode = React.memo(
  ({ data, isConnectable }: BaseNodeProps<TransformScriptConfiguration>) => {
    const title = 'Script'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'filter'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default TransformScriptNode
